import { defineComponent as n, createElementBlock as t, openBlock as o, normalizeClass as s, renderSlot as r, createCommentVNode as a, toDisplayString as l } from "vue";
import { _ as p } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const i = n({
  name: "vs-badge",
  props: {
    color: {
      type: String,
      default: "primary"
    },
    text: {
      type: String,
      default: ""
    }
  },
  setup() {
    return {};
  }
}), d = {
  key: 0,
  class: "px-1"
};
function c(e, f, m, u, $, g) {
  return o(), t("span", {
    class: s(
      `rounded-xl font-sm transition-all duration-500 flex bg-${e.color} text-on-${e.color}`
    )
  }, [
    r(e.$slots, "default"),
    e.text ? (o(), t("span", d, l(e.text), 1)) : a("", !0),
    r(e.$slots, "after")
  ], 2);
}
const x = /* @__PURE__ */ p(i, [["render", c]]);
export {
  x as v
};
//# sourceMappingURL=vsBadge-DmDe4A9x.mjs.map
